// src/config/env.ts

/**
 * Baked in at build time by CRA via REACT_APP_ENV=beta in the beta workflow.
 * On production builds this is undefined → isBeta is false.
 */
export const isBeta = process.env.REACT_APP_ENV === 'beta';

/**
 * True in beta builds or local dev (npm start). False in production.
 * Use this to gate dev-only UI like debug buttons/panels.
 */
export const showDevTools = isBeta || process.env.NODE_ENV === 'development';